'use strict';

const Backbone = require('backbone');
const Marionette = require('backbone.marionette');
const _ = require('lodash');

module.exports = Marionette.Controller.extend({

    initialize: function (options) {
        const me = this;
        _.extend(me, _.pick(options, 'regions'));
    },

    handler: function (curation) {
        const me = this;

        me.runFilters('beforeFilters', curation)
            .then(_.bind(me.showWidgets, me, curation))
            .then(function () {
                curation.loading = false;
                me.runFilters('afterFilters', curation);
            })
            .fail(function () {
                curation.loading = false;
            });
    },

    handleUnknownRoute: function () {
    },

    handleCurationError: function (curation, error) { // jshint ignore:line
    },

    teardownCuration: function (curation) {
        curation.teardown();
    },

    showWidgets: function (curation, replacementView) {
        const me = this;

        if (replacementView) {
            return me.regions.widgetsRegion.show(replacementView);
        }

        const View = curation.getChildView();
        const widgets = new View(curation.getChildViewAttributes());

        const deferred = new Backbone.$.Deferred();
        widgets.on('loading:finished', deferred.resolve);

        window.requestAnimationFrame(function () {
            me.regions.widgetsRegion.show(widgets);

            widgets.waitForAsyncRender(function () {
                me.runFilters('postRenderFilters', curation);
            });
        });

        return deferred;
    },

    runFilters: function (key, curation) {
        const me = this;
        const deferred = new Backbone.$.Deferred();

        try {
            curation.runFilters(key).done(function (result) {
                if (curation.isTornDown) {
                    return deferred.reject();
                }

                if (!result || me.handleFilterResult(result)) {
                    return deferred.resolve(result);
                }

                // NOTE reject w/o error here to stop rendering on navigation
                deferred.reject();
            }).fail(function (error) {
                deferred.reject(error);
            });
        } catch (error) {
            deferred.reject(error);
        }

        deferred.fail(function (error) {
            if (error) {
                me.handleCurationError(curation, error);
            }
        });

        return deferred;
    },

    /*
     * Handles filter results
     * Strings are considered redirects
     *
     * Returns undefined or a view to render in place of the widgets
     */
    handleFilterResult: function (result) {
        if (!result) {
            return result;
        }

        if (result.render) {
            return result;
        }

        if (_.isString(result)) {
            Backbone.history.navigate(result, {
                trigger: true
            });
            return;
        }

        throw new Error('invalid filter result');
    }
});
